const PROFILE_URL_PATH = '/p/';

export const buildProfileUrl = (token: string): string =>
  `${window.location.origin}${PROFILE_URL_PATH}${token}`;

export const buildShareMessage = (
  providerName: string,
  profileUrl: string,
): string =>
  `I just had a great experience with ${providerName} — you might want to check them out:\n${profileUrl}`;

export const buildWhatsAppShareUrl = (message: string): string =>
  `https://wa.me/?text=${encodeURIComponent(message)}`;

export const providerDisplayName = (provider: {
  first_name?: string | null;
  last_name?: string | null;
  business_name?: string | null;
}): string => {
  if (provider.business_name && provider.business_name.trim()) {
    return provider.business_name.trim();
  }
  const first = (provider.first_name ?? '').trim();
  const last = (provider.last_name ?? '').trim();
  const full = [first, last].filter(Boolean).join(' ');
  return full || 'this provider';
};
